import React from "react";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import plant from "../assets/plant.svg";
import w1 from "../assets/w1.jpg";
import w3 from "../assets/w3.jpg";
import { Link } from "react-router-dom";
import { useState } from "react";
import QuoteDialog from "./QuoteDialog";
const Services = () => {
  const [dialogState, setDialogState] = useState(false);
  const toggleDialog = (e) => {
    setDialogState((prev) => !prev);
  };
  const handleKeyClose = (e) => {
    if (e.key === "Escape") {
      setDialogState(false);
      document.body.style.overflow = "auto";
    }
  };
  return (
    <div onKeyDown={(e) => handleKeyClose(e)}>
      <QuoteDialog state={dialogState} toggle={toggleDialog} />
      <div className="bg-primary/80 text-white py-12 relative">
        <div
          className="w-full h-full absolute bg-contain top-0 bg-repeat bg-right -z-10 bg-primary"
          style={{
            backgroundImage: `url(${plant})`,
            backgroundSize: "20% 100%",
          }}></div>
        <div className="max-screen flex flex-col lg:flex-row justify-between items-center gap-6">
          <div>
            <p className="text-2xl xl:text-3xl 2xl:text-4xl font-bold text-center md:text-left">
              {" "}
              Need a Gardener For your Home? Please Call : (941) 288-4338
            </p>
          </div>
          <div>
            <Link
              to="/contact"
              className="btn whitespace-nowrap flex transition-all duration-300 items-start gap-1 bg-white text-primary  2xl:text-xl 
        py-2 px-8 [&>span]:hover:opacity-100 [&>span]:hover:w-4">
              Contact Us
              <span className="opacity-0 w-0 transition-all duration-300">
                <ArrowForwardIcon />
              </span>
            </Link>
          </div>
        </div>
      </div>

      <section className="py-10 lg:py-20 max-screen">
        <h2 className="text-5xl font-bold text-center mb-20">Our Services</h2>
        <div className="flex flex-col lg:flex-row items-center">
          <div className="flex-1 relative overflow-hidden " data-src={w1}>
            <img
              src={w1}
              alt=""
              className="aspect-video md:min-h-[400px] object-cover hover:scale-110 transition-all duration-300"
            />
          </div>
          <div className="flex-1">
            <div className=" px-4 py-6 lg:px-8 flex flex-col gap-2">
              <h3 className="text-2xl 2xl:text-3xl font-medium">
                Landscaping Services
              </h3>

              <p className="text-neutral-3">
                Discover a realm of creativity and innovation with our
                comprehensive landscaping services. From captivating garden
                designs to elegant hardscaping, we specialize in crafting
                outdoor environments that captivate the senses and elevate your
                surroundings. Let our seasoned experts bring your vision to life
                and transform your outdoor space into a breathtaking
                masterpiece.
              </p>
              <div className="flex items-center gap-4 flex-wrap mt-4">
                <Link to="/services/landscaping" className="btn btn-main">
                  Learn More
                </Link>
                <button
                  onClick={toggleDialog}
                  className="btn border border-primary whitespace-nowrap 
                  flex transition-all duration-300 items-start gap-1 bg-white text-primary 
         [&>span]:hover:opacity-100 [&>span]:hover:w-4">
                  Get a Quote{" "}
                  <span className="opacity-0 w-0 transition-all duration-300">
                    <ArrowForwardIcon />
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-col lg:flex-row-reverse items-center">
          <div className="flex-1 relative overflow-hidden" data-src={w3}>
            <img
              src={w3}
              alt=""
              className="aspect-video md:min-h-[400px] object-cover hover:scale-110 transition-all duration-300"
            />
          </div>
          <div className="flex-1 ">
            <div className="flex flex-col gap-2 px-4 py-6 lg:px-8">
              <h3 className="text-2xl 2xl:text-3xl font-medium">
                Lawn Care Services
              </h3>

              <p className="text-neutral-3">
                Experience the epitome of lawn care excellence with our
                meticulous and tailored services. Our dedicated team is
                committed to nourishing and maintaining your lawn's health and
                lushness, ensuring a vibrant green carpet that welcomes you
                home. With our expertise in irrigation, aeration, and precise
                mowing techniques, your lawn will flourish under our care,
                becoming a source of pride and beauty.
              </p>
              <div className="flex items-center gap-4 flex-wrap mt-4">
                <Link to="/services/lawn-care" className="btn btn-main">
                  Learn More
                </Link>
                <button
                  onClick={toggleDialog}
                  className="btn border border-primary whitespace-nowrap 
                  flex transition-all duration-300 items-start gap-1 bg-white text-primary 
         [&>span]:hover:opacity-100 [&>span]:hover:w-4">
                  Get a Quote{" "}
                  <span className="opacity-0 w-0 transition-all duration-300">
                    <ArrowForwardIcon />
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="flex-c mt-12 lg:mt-16 z-10 relative">
          <Link
            to="/services/landscaping"
            className="text-primary hover:text-secondary underline text-xl font-semibold underline-offset-4">
            Discover All
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Services;


